var React = require('react');

function Pets (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.073 1.427V0l-3.81 3.438 2.659 2.708.47-1.022.843.486a1.452 1.452 0 001.751-.243l.778-.778-2.691-3.162zM1.744 3.973c-.422-.47-.681-.924-.778-1.378a.508.508 0 00-.584-.373.506.506 0 00-.373.583c.162.73.616 1.459 1.346 2.157v6.341c0 .373.308.697.681.697h.146a.72.72 0 00.714-.714V8.562l5.757.924v1.751a.76.76 0 00.761.763h.049c.47 0 .843-.389.843-.859v-3.6l.243-.616L7.63 3.973H1.744zm2.854 5.351L3.382 9.13v1.978l.097.259c.162.438.649.681 1.086.519.389-.13.6-.551.486-.941l-.453-1.621z"}));
}

Pets.defaultProps = {"width":"14.765","height":"12","viewBox":"0 0 14.765 12"};

module.exports = Pets;

Pets.default = Pets;
